import { render, staticRenderFns } from "./DaySchedule.vue?vue&type=template&id=effdbf5a&scoped=true&"
import script from "./DaySchedule.vue?vue&type=script&lang=js&"
export * from "./DaySchedule.vue?vue&type=script&lang=js&"
import style0 from "./DaySchedule.vue?vue&type=style&index=0&id=effdbf5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effdbf5a",
  null
  
)

export default component.exports